import { render, staticRenderFns } from "./ManageCompanies.vue?vue&type=template&id=d2e0154c"
import script from "./ManageCompanies.vue?vue&type=script&lang=js"
export * from "./ManageCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports